// Free version - simplified read-only Licensing Tracker
import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
import "../prospect-tracker.css";

export default function FreeLicensingTracker() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [licenses, setLicenses] = useState([]);
  const [loading, setLoading] = useState(true);
  
  // Get filter from URL params
  const recruiterFilter = searchParams.get("recruiter");

  useEffect(() => {
    const fetchLicenses = async () => {
      if (!recruiterFilter) {
        setLoading(false);
        return;
      }
      
      setLoading(true);
      try {
        const q = query(
          collection(db, "prospect_tracker"),
          where("recruiter", "==", recruiterFilter),
          where("licensed", "==", true)
        );
        
        const snapshot = await getDocs(q);
        const data = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setLicenses(data);
      } catch (err) {
        console.error("Error fetching licenses:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLicenses();
  }, [recruiterFilter]);

  const handleReset = () => {
    navigate("/licensing-tracker-free");
  };

  return (
    <div className="tracker-page">
      <div className="tracker-header">
        <h1>Licensing Tracker (View Only)</h1>
        <button className="reset-btn" onClick={handleReset}>
          Reset Filters
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading...</div>
      ) : (
        <div className="tracker-table-container">
          <div className="progress-summary">
            <strong>{licenses.length} / 3 Licenses</strong>
          </div>
          <table className="tracker-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>License Type</th>
                <th>Status</th>
                <th>Recruiter</th>
              </tr>
            </thead>
            <tbody>
              {licenses.length === 0 ? (
                <tr>
                  <td colSpan="5" style={{ textAlign: "center", padding: "20px" }}>
                    No licensed agents found
                  </td>
                </tr>
              ) : (
                licenses.map(license => (
                  <tr key={license.id}>
                    <td>{license.name || "N/A"}</td>
                    <td>{license.email || "N/A"}</td>
                    <td>{license.licenseType || "N/A"}</td>
                    <td>{license.status || "Active"}</td>
                    <td>{license.recruiter || "N/A"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}

      <style>{`
        .progress-summary {
          padding: 15px;
          background: rgba(255, 215, 0, 0.1);
          border-left: 4px solid #ffd700;
          margin-bottom: 20px;
          font-size: 18px;
          color: #ffd700;
        }
      `}</style>
    </div>
  );
}

